export default {
  'health': {
    'aggregateData': {
      'registeredUsers': 'registered users',
      'activeUsers': 'active users',
      'hoursOfActivity': 'hours of activity',
      'hoursOfSleep': 'hours of sleep',
      'kgC02Saving': 'kg CO2 saving',
      'steps': 'steps',
      'kmTravelled': 'km travelled',
      'savedTrees': 'saved trees',
      'smartphoneCharges': 'smartphone charges',
      'co2ToElectricEnergy': 'CO2 to electric energy',
      'sleepTrend': 'Sleep trend',
      'activityTrend': 'Activity trend',
      'stepsTrend': 'Steps trend',
      'kmTravelledTrend': 'Km travelled trend',
      'corporateDashboard': 'Corporate Dashboard'
    },
    'nightScout': 'Nightscout',
    'changePassphrase': {
      'title': 'Change passphrase',
      'success': 'Passphrase updated successfully',
      'error': 'An error has occurred while changing passphrase',
      'generate': 'Generate',
      'passphraseInUse': 'Passphrase is already in use'
    },
    'integrate': 'integrate',
    'integration': {
      'success': 'Integration completed successfully!',
      'error': 'An error occurred during integration.',
      'notEnoughScopes': 'To complete the integration you should grant all the requested permissions',
      'noAccount': 'There is no Google Fit account linked to your Google account',
      'noRefreshToken': 'An error occurred during integration. Please, remove the access from Google Fit app and try again',
      'manageIntegration': 'Manage integration',
      'integrationModalText': 'What do you want to do with {platform}?',
      'reIntegrate': 'Reintegrate',
      'removeIntegration': 'Remove integration',
      'integrationRemoved': 'Integration has been removed successfully',
      'integrationRemovedError': 'An error has occurred while removing integration'
    },
    'healthBoard': 'Glucoboard',
    'my-patients': {
      'title': 'My patients',
      'loading': 'Loading patients...',
      'empty': 'You do not have any assigned patients yet.',
      'retry': 'Retry',
      'error': 'An error occurred while loading patients. Please try again.',
      'table': {
        'id': 'ID',
        'username': 'Username',
        'name': 'Name',
        'surname': 'Surname',
        'email': 'Email'
      }
    },
    'foodManager': {
      'title': 'Food Manager',
      'nameEsp': 'Nombre',
      'nameEng': 'Name (English)',
      'group': 'Grupo',
      'portion': 'Porción',
      'fat': 'Grasa(g)',
      'protein': 'Proteína(g)',
      'kcl': 'Kcals (kj)',
      'carbs': 'Carbs(g)',
      'fiber': 'Fibra(g)',
      'water': 'Agua(g)',
      'alcohol': 'Alcohol(g)',
      'successDelete': 'Food {name} deleted',
      'errorDelete': 'Error deleting {name} food'
    },
    'summary': {
      'meal': 'Meal',
      'max': 'Stabilisation of the basal level',
      'peak': 'Max Reached',
      'diff': 'Difference Begin/End',
      'title': 'Summary',
      'caloriesUnit': 'Calories (kcal)',
      'fatUnit': 'Fat (g)',
      'proteinUnit': 'Protein (g)',
      'carbsUnit': 'Carbs (g)',
      'calories': 'Calories',
      'fat': 'Fat',
      'protein': 'Protein',
      'carbs': 'Carbs',
      'fibre': 'Fibre',
      'caloriesWeight': 'Calories/kilo (kcal/kg)',
      'takeIntoAccount': 'Add to summary',
      'fatWeight': 'Fat/kilo (g/kg)',
      'proteinWeight': 'Protein/kilo (g/kg)',
      'carbsWeight': 'Carbs/kilo (g/kg)',
      'day': 'Day',
      'button': 'Show macros\' details',
      'glucoscore': 'Glucoscore',
      'average': 'Average',
      'vibeBattery': 'VibeBattery',
      'weightTitle': '{value} kcal/kg',
      'kcalTitle': '{value} kcal',
      'grams': 'grams',
      'kcals': 'kcals',
      'averageMacros': 'Macronutrients Average',
      'averageMacrosKilo': 'Macronutrients Average/kg',
      'greenScore': 'Low',
      'orangeScore': 'Moderate',
      'redScore': 'High',
      'impact': 'Impact',
      'glucoscoreInfo': 'The Glucoscore evaluates the impact of an intake on your glycemic curve. This metric helps you understand how your food intake affects you.',
      'vibeBatteryInfo': 'Vibebattery is your daily energy. It is a mathematical relationship between different variables, both objective and subjective, which represents the state of your body to withstand the different stimuli of life.',
      'isp': 'ISP (Lasting Satiety Index)',
      'macroDistribution': 'Macronutrient distribution'
    },
    'gpxIngestFile': 'GPX file',
    'explorer': {
      'title': 'Glucoboard',
      'multipleBoard': {
        'title': 'Multiscreen',
        'selectUsers': 'Select users'
      },
      'controls': 'Last 7 days from',
      'controls14': 'Last 14 days from',
      'controls30': 'Last 30 days from',
      'controlsDay': 'Data of the day',
      'controls30Simple': 'Last 30 days',
      'userSelector': 'Show user data for',
      'groupSelector': 'Show group data for',
      'show': 'Show',
      'heartRate': 'Heart rate',
      'intensity': 'Intensity',
      'sport': 'Sport',
      'event': 'Event',
      'foods': 'Foods',
      'amount': 'Amount',
      'carbohydrates': 'CH',
      'proteins': 'P',
      'fats': 'G',
      'questionnaire': {
        'notes': 'Notes',
        'fastingHunger': 'Waking up hunger',
        'glucoseBasal': 'Glucose basal',
        'restingHr': 'Resting heart rate',
        'hrVariability': 'HRV',
        'sickness': 'Sick',
        'sleepQuality': 'Sleep quality',
        'sleepTime': 'Sleep time',
        'tiredness': 'Energy',
        'anxietyLevel': 'Anxiety level',
        'dayEvaluation': 'Day evaluation',
        'nutritionPlan': 'Exceptional nutrition',
        'outOfRoutine': 'Travel or exceptional routine',
        'trainingEffort': 'Training effort',
        'sleepTimeStart': 'Bedtime',
        'sleepTimeEnd': 'Time to get up',
        'yes': 'Yes',
        'no': 'No'
      },
      'glucoscore': {
        'redScore': 'High impact',
        'orangeScore': 'Moderate impact',
        'greenScore': 'Low impact',
        'auc': 'AUC',
        'peak': 'Peak',
        'stabilization': 'Stabilization',
        'amplitude': 'Amplitude',
        'processing': 'Your intake is being analyzed, you will soon be able to see the evaluation.',
        'couldNotCalculateYet': 'Glucose samples from two hours after ingestion are needed so that it can be evaluated.',
        'notSamples': 'Your intake could not be evaluated because there are no glucose samples.',
        'notEnoughSamples': 'Your intake could not be evaluated because there are not enough glucose samples.',
        'duringSport': 'Your intake could not be evaluated because it was taken during a period of activity.',
        'beforeSport': 'Your intake could not be evaluated because it was taken shortly before a period of activity.',
        'tooCloseToMeal': 'Your intake could not be evaluated because it was too close to the previous intake.',
        'notCalculated': 'Your intake score could not be calculated.'
      }
    },
    'analytics': {
      'notFoundNames': {
        'menuTitle': 'Invalid Names',
        'title': 'Biomarkers not found',
        'columns': {
          'extractedName': 'Extracted Name',
          'unit': 'Unit',
          'value': 'Value',
          'resolve': 'Resolve'
        },
        'selectPlaceholder': 'Select biomarker...',
        'recommended': 'Recommended',
        'otherBiomarkers': 'Other biomarkers',
        'noUnit': 'No unit',
        'accept': 'Accept',
        'reject': 'Reject',
        'alerts': {
          'selectFirst': 'Please select a biomarker from the dropdown first.',
          'saveError': 'Could not save the resolution.',
          'rejectConfirm': 'Are you sure you want to reject \'{name}\'?',
          'rejectError': 'Could not reject the biomarker.'
        }
      },
      'notFoundUnits': {
        'menuTitle': 'Manage analytics possible units',
        'title': 'Biomarker Units Review',
        'originalUnit': 'Extracted Unit',
        'suggestedUnit': 'Suggested Unit / Mapping',
        'accept': 'Accept',
        'reject': 'Reject',
        'save': 'Save',
        'empty': 'No pending units to review.',
        'successAccept': 'Unit successfully mapped and accepted',
        'successReject': 'Unit successfully rejected',
        'errorAction': 'An error occurred while processing the unit'
      },
      'categories': {
        'menuTitle': 'Manage analytics categories'
      },
      'history': {
        'menuTitle': 'Analytics history'
      },
      'list': {
        'title': 'Analytics History',
        'date': 'Date',
        'notes': 'Notes / Details',
        'noNotes': 'No notes',
        'empty': 'No analytics available.'
      },
      'evaluation': {
        'title': 'Analytics Categories',
        'categoryFallback': 'Category',
        'biomarkerFallback': 'Biomarker',
        'noData': 'No data',
        'empty': 'No categories available or loading...',
        'evolutionTitle': 'Historical Evolution',
        'loadingHistory': 'Loading history...',
        'noHistory': 'Not enough historical data.',
        'value': 'Value'
      }
    },
    'xugarboard': {
      'duration': 'Duration'
    },
    'signin': {
      'license': 'License (Optional)',
      'notValidLicense': 'License code is invalid'
    },
    'login': {
      'title': 'Welcome to My Glucovibes',
      'licenseError': 'Your license has expired'
    },
    'updateLicense': {
      'title': 'Update license',
      'expirationDate': 'Expiration date',
      'subscriptions': 'Subscriptions',
      'addSubscription': 'Add subscription',
      'update': 'Update',
      'success': 'License has been updated successfully',
      'shop': 'Need a new license? You can aquire it <a href="https://glucovibes.com/tienda/">here</a>',
      'accountSuccessfullyActivated': 'Your Viber plan has been successfully activated',
      'errorActivatingAccount': 'An error has occurred while activating your Viber plan',
      'errorActivatingAccountAlreadyHaveEntitlement': 'You already have an active Viber plan.',
      'errorActivatingAccountInvalidLicense': 'Please check the provided license key or URL and ensure it is correct. If you believe this is an error, please contact <a href="mailto:soporte@xugarhero.com">soporte@xugarhero.com</a> for assistance.',
      'errorActivatingAccountDetailsRetry': 'Please, try again in a few minutes or contact with <a href="mailto:soporte@xugarhero.com">soporte@xugarhero.com</a> if the error persists.',
      'errorActivatingAccountDetails': 'Please, contact with <a href="mailto:soporte@xugarhero.com">soporte@xugarhero.com</a>.'
    },
    'settings': {
      'userSensorTime': 'User Sensor Time',
      'supervisors': 'Supervisors'
    },
    'supervisor': {
      'pending': 'Pending',
      'invite': 'Invite',
      'usernameOrEmail': 'Username or email',
      'remove': 'Are you sure you want to remove permission?',
      'errorDelete': 'An error has occurred while removing {name}\'s permission',
      'successDelete': '{name} won\'t be able to see your data',
      'errorInviteNotFound': '{name} could not be found',
      'errorConflictInvite': '{name} has already been invited see your data',
      'successInvite': '{name} has been successfully invited',
      'errorInvite': 'An error has occurred while inviting {name}',
      'errorYourselfInvite': 'You can\'t invite youself'
    },
    'manageAccess': {
      'title': 'Manage my access',
      'removeAccessTitle': 'Remove access',
      'removeAccessMessage': 'Are you sure you want to remove access?',
      'successAccessDelete': 'Access to {name} has been successfully removed',
      'errorAccessDelete': 'An error has occurred while removing {name}\'s access',
      'successAcceptInvitation': 'Invitation has been successfully accepted',
      'errorAcceptInvitation': 'An error has occurred while accepting invitation',
      'successDeclineInvitation': 'Invitation has been successfully declined',
      'errorDecliningInvitation': 'An error has occurred while declining invitation',
      'removePendingMessage': 'Decline invitation',
      'removePendingTitle': 'Are you sure you want to decline the invitation?',
      'invitations': 'Invitations'
    },
    'sensor': {
      'title': 'Active Sensors',
      'time': 'Time',
      'day': 'Day',
      'hour': 'Hour',
      'sensor': 'Sensor',
      'supervisor': 'Supervisor',
      'noSupervisor': 'No supervisor'
    },
    'userProfile': {
      'expirationDate': 'Expiration date',
      'nutritionalPlanExpirationDate': 'Nutritional plan expiration date',
      'prescriptor': 'Prescriptor',
      'license': 'License',
      'prescriptorDoesNotMatchUser': 'There is no prescriptor/nutritionist matching that username',
      'update': 'Update',
      'expired': 'This user\'s license has expired',
      'nutritionalPlanExpired': 'This user does not benefit from a nutritional plan',
      'address': 'Address',
      'noAddress': 'User hasn\'t introduced any address',
      'upgradeToViber': 'Obtain Viber subscription',
      'upgradeToViberPlus': 'Obtain Viber Plus+ subscription',
      'deleteAccount': {
        'title': 'Delete account',
        'message': 'Are you sure that you want to delete your account? This action cannot be undone',
        'successMessage': 'Your account has been successfully deleted',
        'errorMessage': 'An error has occurred while deleting your account'
      }
    },
    'nutritionalPlanTemplate':{
      'title': 'Nutritional Plan Templates',
      'description': 'Description',
      'create': 'Create new template',
      'delete': 'Are you sure you want to delete it?',
      'new': 'Create new template',
      'edit': 'Edit template',
      'selector':'Select template',
      'loading': 'Loading templates...',
      'noTemplate': 'You have no templates created',
      'errorLoading': 'Error loading the templates',
      'errorRecipes': 'Error loading the recipes of the template',
      'confirmApply': 'Are you sure you want to apply this template? It will replace the current plan.',
      'saveTemplate': 'Save',
      'confirmSave': 'The template has been saved successfully',
      'errorChangeRecipe': 'Error changing the recipe: ',
      'errorGettingRecipes': 'Error retrieving recipes from the template: ',
      'saveAsTemplate': 'Save as template'
    },
    'nutritionalPlan': {
      'meal': 'Meal',
      'exportPdf': 'Export',
      'menu': 'Nutritional plan',
      'calendar': 'Nutrition calendar',
      'title': 'Ingests',
      'addIngest': 'Add ingest',
      'addTemplate': 'Add template',
      'addFood': 'Add food',
      'name': 'Name',
      'type': 'Type',
      'intensity': 'Intensity',
      'active': 'Active',
      'amount': 'Amount (g)',
      'foodAmount': 'Amount',
      'templateSelector': 'Template Selector',
      'templates': 'Templates',
      'foods': 'Foods',
      'food': 'Food',
      'foodsSelector': 'Food selector',
      'delete': 'Delete Plan',
      'deleteFood': 'Delete food',
      'editFormTitle': 'Edit Ingest',
      'editTemplate': 'Edit Template',
      'noWeight': 'This user hasn\'t introduced his weight',
      'maxIngestsOfType': 'You have selected the maximum number of ingests for types',
      'mealTypes': [
        'Breakfast',
        'Morning snack',
        'Lunch',
        'Afternoon snack',
        'Dinner'
      ], 'mealTypes2': {
        'Desayuno': 'Breakfast',
        'Almuerzo': 'Lunch',
        'Comida': 'Meal',
        'Merienda': 'Snack',
        'Cena': 'Dinner'
      },
      'weekDays': {
        'monday': 'Monday',
        'tuesday': 'Tuesday',
        'wednesday': 'Wednesday',
        'thursday': 'Thursday',
        'friday': 'Friday',
        'saturday': 'Saturday',
        'sunday': 'Sunday'
      },
      'selectDayAndMealType': 'Select a day and meal type',
      'noPlan': 'The user does not have any assigned plan'
      ,
      'colors': {
        'white': 'White',
        'red': 'Red',
        'yellow': 'Yellow',
        'purple': 'Purple',
        'green': 'Green'
      },
      'gramsKilo': 'Grams / kg',
      'percentage': 'Percentage',
      'free': 'Freestyle',
      'modeTitle': 'User\'s nutrition plan working mode',
      'successUpdateMode': 'This user\'s mode has been updated successfully',
      'errorUpdateMode': 'An error has occurred while updating mode',
      'successUpdate': 'Ingest has been updated successfully',
      'successTemplateUpdate': 'Template has been updated successfully',
      'errorUpdate': 'An error has occurred while updating ingest',
      'errorTemplateUpdate': 'An error has occurred while updating template',
      'successCalendarUpdate': 'Week planning has been updated successfully',
      'errorCalendarUpdate': 'An error has occurred while updating week planning',
      'successDelete': 'Ingest {name} deleted',
      'successTemplateDelete': 'Template {name} deleted',
      'errorDelete': 'Error deleting {name} ingest',
      'errorTemplateDelete': 'Error deleting {name} template',
      'errorFoodInfo': 'An error has occurred while adding food',
      'protein': 'Protein (g)',
      'fat': 'Fat (g)',
      'carbs': 'Carbs (g)',
      'calories': 'Calories (kcal)',
      'proteinKg': 'Protein (g/kg)',
      'fatKg': 'Fat (g/kg)',
      'carbsKg': 'Carbs (g/kg)',
      'caloriesKg': 'Calories (kcals/kg)',
      'fibre': 'Fibre (g)',
      'modifyAmount': 'Modify amount',
      'amountInG': 'Amount in grams',
      'amountModifyError': 'A number should be introduced',
      'carbsFactor': 'Carbs factor ',
      'fatsFactor': 'Fats factor',
      'proteinsFactor': 'Proteins factor',
      'caloriesFactor': 'Calories factor',
      'theoreticalTotal': 'Theoretical total (g)',
      'realTotal': 'Real total (g)',
      'recalculate': 'Recalculate',
      'adjustAmounts': 'Adjust amounts',
      'errorExceededCarbs': 'The foods avoided for adjustment have already exceeded the amount of needed carbs',
      'negativeAmount': 'Amount can\'t be negative',
      'carbsFactorZero': 'Carbs factor should be higher than 0',
      'negativeFactors': 'Macros\' factors should be higher than 0',
      'typeNotSelected': 'Please choose the type of ingest',
      'planNameConflict': 'A nutritional plan with that name already exists',
      'templateNameConflict': 'A template with that name already exists',
      'notGramsKiloMode': 'This user doesn\'t use grams/kg mode',
      'show': 'Show',
      'successUpdateVisibility': 'Ingest visibility has been updated successfully',
      'errorUpdateVisibility': 'An error has occurred while updating ingest visibility',
      'summary': 'Summary',
      'selectDay': 'Select day',
      'selectMeal': 'Select type of meal',
      'addRecipe': 'Add recipe',
      'ingredients': 'Ingredients',
      'addFoodGroup13': 'Add supplements',
      'recipesSelector': 'Recipes Selector',
      'recipes': 'Recipes',
      'filterByTag': 'Filter by Tag',
      'allTypes': 'Filter by Type',
      'glucoseCurve': 'Predicted glucose assessment (mg/dL)',
      'timeMinutes': 'Time (minutes)',
      'upperLimit': 'Upper limit',
      'lowerLimit': 'Lower limit',
      'updateRecipe': 'The plan has been successfully modified',
      'update': 'Update',
      'recipeAlreadyAssigned': 'There is already a recipe assigned for this day and meal type. Would you like to replace it?',
      'errorUpdateRecipe': 'Error updating the plan',
      'reset': 'Start from scratch',
      'confirmReset': 'Are you sure you want to delete the plan?',
      'noLooseFood': 'You can only add ingredients to a recipe',
      'assign28Days': 'Assign 28-day plan',
      'confirm28Days': 'Are you sure you want to assign this 28-day plan? Existing data will be overwritten.',
      'planAssigned': '28-day plan successfully assigned.',
      'errorAssignPlan': 'Error assigning the 28-day plan.',
      /* Prototype */
      'prototype': {
        'noNutritionalPlanResult': 'No nutritional plan result for provided kcal',
        'recalculate': 'Recalculate',
        'daysOfPlan': 'Days of plan',
        'breakfast': 'Breakfast',
        'breakfastSnack': 'Breakfast snack',
        'lunch': 'Lunch',
        'lunchSnack': 'Lunch snack',
        'dinner': 'Dinner',
        'total': 'Total',
        'addBreakfastSnack': 'Add breakfast snack',
        'addLunchSnack': 'Add lunch snack',
        'weekdays': [
          'Monday',
          'Tuesday',
          'Wednesday',
          'Thursday',
          'Friday',
          'Saturday',
          'Sunday'
        ],

      }
    },
    'subscription': {
      'title': 'Subscription',
      'daily': 'One day',
      'threeDays': 'Three days',
      'weekly': 'One week',
      'monthly': 'One month',
      'twoMonths': 'Two months',
      'threeMonths': 'Three months',
      'sixMonths': 'Six months',
      'yearly': 'One year',
      'lifetime': 'Lifetime'
    },
    'license': {
      'license': 'License',
      'description': 'Description',
      'entitlement': 'Entitlement',
      'duration': 'Duration',
      'order': 'Order',
      'productId': 'Product Id',
      'date': 'Date',
      'new': 'New license',
      'deleteModalMessage': 'Delete license',
      'successDelete': 'License has been successfully deleted',
      'errorDelete': 'An error has occurred while deleting license',
      'coupon': 'Coupon',
      'invalidCoupon': 'Invalid coupon',
      'amount': 'Amount',
      'successProcessLicenses': 'Licenses has been successfully created',
      'errorProcessLicenses': 'An error has occurred while processing licenses'
    },
    'patient': {
      'title': 'Patients',
      'username': 'Username',
      'name': 'Name',
      'surname': 'Surname',
      'email': 'Email',
      'sex': 'Sex',
      'weight': 'Weight',
      'height': 'Height',
      'objective': 'Objective',
      'weeklyTrainings': 'Weekly trainings',
      'averageTrainingTime': 'Average training time',
      'objectiveWeight': 'Objective weight',
      'caloricNeeds': 'kcals',
      'birthday': 'Birthday',
      'integrations': 'Integrations',
      'sexType': {
        'masculine': 'Masculine',
        'feminine': 'Feminine'
      },
      'firstOption': 'Nutritional Plan',
      'secondOption': 'Evolution',
      'thirdOption': 'Note',
      'objectiveType': {
        'loseWeight': 'Lose weight',
        'gainMuscleMass': 'Gain muscle mass',
        'improveSportPerformance': 'Improve sport performance',
        'learnToEatBetter': 'Learn to eat better',
        'improveRestQuality': 'Improve rest quality',
        'feelMoreEnergetic': 'Feel more energetic'
      }
    },
    'assignPatients': {
      'title': 'Assign patients',
      'nutritionistSelector': 'Nutritionist selector',
      'nutritionists': 'Nutritionists',
      'successAssignNutritionist': 'Nutritionist has been successfully assigned'
    },
    'exploreRecommendations': {
      'title': '\'Explore\' recommendations',
      'recommended': 'Recommended',
      'name': 'Name',
      'errorUpdating': 'An error has occurred while updating recommendations',
      'successUpdating': 'Recommendations have been successfully updated'
    },
    'challenge': {
      'newTemplate': 'Add template',
      'templates': 'Challenge templates',
      'challenges': 'Challenges',
      'activeAndFutureChallenges': 'Active and future challenges',
      'category': 'Category',
      'categories': {
        'glucose': 'Glycemia',
        'sport': 'Activity',
        'nutrition': 'Nutrition',
        'rest': 'Rest'
      },
      'type': 'Type',
      'types': {
        'accumulated': 'Accumulated',
        'accumulatedLabel': 'Accumulated (Take 100,000 steps this month.)',
        'streak': 'Streak',
        'streakLabel': 'Streak (Take 10,000 steps a day for 5 days in a row this month.)',
        'days_count': 'Days fullfilling',
        'days_countLabel': 'Days fullfilling (Take 10,000 steps a day at least 5 days this month.)'
      },
      'operatorTypes': {
        'first': 'First value',
        'last': 'Last value',
        'count': 'Number of values',
        'min': 'Minimum',
        'max': 'Maximum',
        'sum': 'Sum of values',
        'avg': 'Average value',
        'vibeBattery': 'VibeBattery'
      },
      'name': 'Name ES',
      'nameEng': 'Name EN',
      'description': 'Description ES',
      'descriptionEng': 'Description EN',
      'resultDescription': 'Result description ES',
      'resultDescriptionEng': 'Result description EN',
      'formula': 'Formula',
      'startDate': 'Start date',
      'endDate': 'End date',
      'daysOfDuration': 'Days of duration',
      'level': 'Level',
      'levels': 'Levels',
      'addLevel': 'Add level',
      'streakDays': 'Streak days',
      'fulfillingDays': 'Fulfilling days',
      'accumulatedValue': 'Accumulated value',
      'addVariable': 'Add variable',
      'addConstant': 'Add constant',
      'categoryNotSelectedError': 'Category has not being selected',
      'noVariablesDataError': 'There are no variables to create the formula',
      'noLevelsError': 'At least one level has to be added',
      'incompleteLevelDataError': 'Levels\' data is incomplete, fill in all the fields',
      'incompleteVariableDataError': 'Variables\' data is incomplete, fill in all the fields',
      'incompletecomparationVariableDataError': 'Comparation variable\'s data is incomplete, fill in all the fields',
      'maxLevelValueHigherThanDurationError': 'Level value can\'t be higher than the duration of the challenge.',
      'levelValueLowerThanZeroError': 'Level value can\'t be 0 or lower.',
      'levelValuesAreNotAscending': 'The level values are not sorted in ascending order.',
      'levelValuesAreNotConsistentlyAscendingOrDescending': 'The level values are not sorted in ascending or descending order.',
      'successDeleteTemplate': 'Template has been sucessfully deleted',
      'deleteTemplateModalMessage': 'Are you sure that you want to remove the template? This action cannot be undone',
      'errorDeleteTemplate': 'An error has occurred while removing template',
      'errorTemplateCreate': 'An error has occurred while creating template',
      'launchChallenge': 'Launch challenge',
      'confirmLaunchMessage': 'Are you sure that you want to launch the challenge? This action cannot be undone',
      'successChallengeCreated': 'Challenge has been successfully created',
      'errorChallengeCreated': 'An error has occurred while creating the challenge',
      'resultDescriptionFormat': 'Add %s where you want to display the accumulated value e.g. You have practised sport for %s minutes.',
      'errorFetchingVariableReferences': 'An error has occurred fetching variable references.',
      'history': 'History',
      'finishedChallenges': 'Finished challenges',
      'participants': 'Participants',
      'participant': {
        'username': 'Username',
        'email': 'Email',
        'maxLevel': 'Reached level',
        'accumulatedValue': 'Accumulated value',
        'maxStreak': 'Max streak',
        'currentStreak': 'Current streak',
        'daysFulfilling': 'Days fulfilling',
        'joinedAt': 'Joined at',
        'lastUpdate': 'Last update'
      }
    },
    'notificationMessages': {
      'title': 'Notifications',
      'messageCode': 'Code',
      'type': 'Type (Es)',
      'typeEng': 'Type (Eng)',
      'inAppMessage': 'In app message (Es)',
      'inAppMessageEng': 'In app message (Eng)',
      'pushMessage': 'Push message (Es)',
      'pushMessageEng': 'Push message (Eng)',
      'push': 'Push',
      'inApp': 'In app',
      'addMessage': 'Add message',
      'editMessage': 'Edit message',
      'messageCodeAlreadyExists': 'The message code already exists',
      'messageSuccessfullyCreated': 'Message has been successfully created',
      'messageSuccessfullyUpdated': 'Message has been successfully updated',
      'new': 'New message',
      'types': {
        'glucose': 'Glucose',
        'nutrition': 'Nutrition',
        'activity': 'Activity',
        'vibeBattery': 'VibeBattery',
        'rest': 'Rest',
        'questionnaire': 'Questionnaire',
        'challenge': 'Challenge',
        'happyBirthday': 'Happy Birthday Viber!',
        'other': 'Other'
      }

    },
    'recipe': {
      'title': 'Recipes',
      'new': 'Add recipe',
      'edit': 'Edit recipe',
      'delete': 'Delete recipe',
      'name': 'Name (Es)',
      'nameEn': 'Name',
      'type': 'Type',
      'glutenFree': 'Gluten free',
      'vegetarian': 'Vegetarian',
      'vegan': 'Vegan',
      'pescetarian': 'Pesce-vegetarian',
      'ketogenic': 'Ketogenic',
      'basicCooking': 'Basic cooking',
      'successDelete': 'Recipe has been successfully deleted',
      'errorDelete': 'An error has occurred while deleting recipe',
      'successUpdate': 'Recipe has been successfully updated',
      'errorUpdate': 'An error has occurred while updating recipe',
      'successCreate': 'Recipe has been successfully created',
      'errorCreate': 'An error has occurred while creating recipe',
      'errorNoType': 'Recipe has to have a type',
      'recipeHasToHaveItemsError': 'Recipe has to have at least one item',
      'uploadImage': 'Upload image',
      'errorImageUpload': 'An error has occurred while uploading image',
      'errorNoImage': 'The recipe has to have an image',
      'totalGrams': 'Total (g)',
      'totalKcals': 'Total (kcal)',
      'kcalDistribution': 'Kcal distribution',
      'predictedScore': 'Predicted score',
      'predictedIsp': 'Predicted ISP',
      'favorites': 'Favorites',
      'myRecipes': 'My recipes',
      'tags': 'Recipe tags',
      'tag': {
        'title': 'Tags',
        'name': 'Name (ES)',
        'nameEn': 'Name',
        'new': 'Add tag',
        'edit': 'Edit tag',
        'delete': 'Delete tag',
        'successDelete': 'Tag has been successfully deleted',
        'errorDelete': 'An error has occurred while deleting tag',
        'successUpdate': 'Tag has been successfully updated',
        'errorUpdate': 'An error has occurred while updating tag',
        'successCreate': 'Tag has been successfully created',
        'errorCreate': 'An error has occurred while creating tag',
        'nameExists': 'Tag with that name already exists'
      },
      'glucoVibesRecipes':'Glucovibes recipes',
      "recipePreviewInfo": "You can explore how adjusting ingredient quantities impacts on macronutrients, ISP and more. Any changes are for guidance only and will not be saved."
    },
    'menu': {
    'challengeManagement': 'Challenge management',
    'nutritionalPlanTest': 'Nutritional plan test'
  },
  'corporateGroups': {
    'title': 'Corporate groups',
    'addCorporateGroup': 'Add corporate group',
    'name': 'Name',
    'group': 'Group',
    'domain': 'Domain',
    'domainWithoutAt': 'Domain without @ (e.g. glucovibes.com)',
    'activePlan': 'Active Viber plan',
    'groupWithDomainAlreadyExists': 'Group with that domain already exists',
    'errorGettingGroups': 'An error has occurred while getting groups'
  }, 'NutritionistNotes': {
    'title': 'Notes from the nutritionist',
    'empty': "No notes yet ",
    'allergies': 'Allergies',
    'intolerances': 'Intolerances',
    'preferences': 'Preferences',
    'food_dislike': 'Food dislike',
    'supplements': 'Supplements',
    'additional_comment': "Additional comment",
    'edit': 'Edit note',
    'delete': 'Delete note',
    'titleEdit': 'Note editor',
    'titleCreate': 'Note creator',
    'save': 'Save note',
    'create': 'Create note',
    'confirmDelete': 'Delete it',
    'deleteConfirm': '¿Are you sure you want to delete this note?',
    'cancel': 'Cancel',
    'menu': 'Notes from the nutritionist',
    'selectPatient': 'Select a patient',
    'addNote': 'Add note'

  }
},
  'legal-termAndConditions': `
    <div>
      <h2>Condiciones de Uso y Aviso Legal</h2>
      <p>
          Con el ánimo de cumplir con lo establecido en la ley 34/2002 de Servicios de la Sociedad de la Información y de Comercio Electrónico (LSI) se ofrece aquí información importante al usuario y a sus tutores en caso de que éste sea menor.
          Para cualquier aclaración o información adicional pueden dirigirse a:
      </p>
      <ul>
          <li>Empresa: : HX Digital Health SL (en adelante xugarhero)</li>
          <li>Nombre Comercial: xugarhero</li>
          <li>B05335377</li>
          <li>Sede fiscal: Juan Fermín Gilisagasti n2 oficina 312, 20018 Donostia, Gipuzkoa (España)</li>
          <li>Correo electrónico: info@xugarhero.com</li>
          <li>sitios web: www.xugarhero.com</li>
          <li>Aplicaciones oficiales en los Store Google Play y AppleStore.</li>
          <li>El fundador de xugarhero y sus socios son los propietarios de esta iniciativa y las derivadas de ésta.</li>
      </ul>
      <p>
        Los productos y servicios de xugarhero a los que el usuario final pueda acceder bien a través de Apps o directamente a través de un navegador web, estarán sujetos a las siguientes condiciones de uso con los consiguientes avisos legales mostrados en este documento.
      </p>

      <h3>Condiciones de uso</h3>
      <p>
      La iniciativa xugarhero y los productos y servicios de xugarhero particularizados para el sector salud, deporte, nutrición o similar en el que información del usuario tanto procedente de sensores (CGM) como introducida por éste o terceros a los que se ha permitido acceso estarán sujetos a estas condiciones de uso y futuras que podrán ser actualizadas en futuras versiones de este documento.
      </p>
      <p>
      El usuario utiliza sistemas CGM comerciales aportados por terceras empresas para generar información que xugarhero almacena. xugarhero y sus iniciativas en ningún caso sustituye a los servicios ofrecidos por el fabricante de los sistemas de medición de glucosa en continuo y sus CGMs, y los servicios de xugarhero no podrán ser utilizados para ningún tipo de diagnóstico o prescripción médica sustitutivos a los ya prestados por las aplicaciones o servicios de los fabricantes o distribuidores de los sistemas CGM de aplicación médica
      </p>
      <p>
      Los servicios e información ofrecida por xugarhero a través de su plataforma digital y/o aplicaciones móviles tienen carácter informativo y complementario a la información facilitada por el fabricante de los sistema CGM, y siempre fuera del ámbito del diagnóstico de salud, y siempre ligados a conocer cómo fluctúa la glucosa ante diferentes situaciones de la persona “no diabética” que haga uso de estos productos o servicios ofrecidospor xugarhero.
       </p>
      <p>
      El hecho de acceder a, permanecer en o usar dichos servicios o productos en cualquier de sus formas posibles implica que usted y las personas que puedan depender de usted, o terceras personas a las que dé acceso, han leído y aceptan en su totalidad este Aviso Legal y Condiciones de Uso así como la Política de Privacidad de xugarhero asociada a los datos manejados por los servicios y productos derivados de las iniciativas mencionadas. Tiene información para su conocimiento en los diferentes lugares públicos en la web que le rogamos leer con detalle para conocer la descripción, dimensión e impacto de los productos y servicios ofrecidos.
      </p>
      <p>
      A través de xugarhero, el cliente accede a una serie de servicios y productos desarrollados por la empresa y sus proveedores. El hecho de ser usuario de estas apps y servicios o productos web ofrecidos por xugarhero convierte al usuario en cliente, en caso de uso por parte de un menor, éste deberá tener consentimiento de bien su progenitor o progenitores o bien de su tutor o tutores. Los usuarios por el hecho de usar los servicios y productos descritos están de acuerdo con las Condiciones de Uso y Aviso Legal y la Política de Privacidad. En caso de no estar de acuerdo con ellas, deberá abandonar los servicios y productos de la iniciativa borrando incluso las apps de sus terminales móviles y solicitar el borrado de cualquier información facilitada por email a baja@xugarhero.com.
      </p>
      <p>
      Usted tiene la posibilidad de sumarse a este programa y participar en un análisis clínico donde la información y datos procedentes del usuario serán utilizados con fines científicos y comerciales para poder mejorar tanto el producto como para la promoción del mismo y su comercialización o cualquier otra actividad que xugarhero considere de interés. Salvo que indique lo contrario, la información facilitada al sistema será utilizada con estos fines garantizando la privacidad de sus datos y utilizando los mismos exclusivamente para fines científicos. El programa científico se aplica por defecto a todos los usuarios que acepten las condiciones de uso y aviso legal.
      </p>
      <p>
      El usuario al registrarse proporciona un nombre completo, nombre de usuario y correo electrónico así como información básica que será tratada y almacenada por xugarhero del mismo modo que la información agregada por el usuario de forma manual o bien a través de terceras partes como pueden ser sensores, otras apps o servicios web, productos de terceros o similar. La aplicación ofrece un modo “invitado” que aquellos usuarios que no deseen registrarse podrán utilizar. Este modo invitado está limitado solo a algunas opciones y está sujeto a cambios e incluso su permanencia puede ser modificada y decidida por xugarhero de forma unilateral sin consentimiento alguno por parte de los usuarios.
      </p>
      <p>
      xugarhero no se hace responsable de los privilegios de instalación otorgados por un tutor a una persona menor. En el caso de xugarhero orientado al tratamiento, gestión y educación diabetológica, se sugiere encarecidamente la supervisión de un adulto o tutor cuando el menor esté utilizando las apps, productos o servicios. xugarhero no es una herramienta de diagnóstico y cualquier decisión tomada por el usuario o su progenitor exonera a xugarhero y sus proveedores e incluso a los fabricantes de los sistemas CGM utilizados por el usuario con los productos de xugarhero de cualquier responsabilidad.
      </p>
      <h3>Exclusión de responsabilidad</h3>
      <p>
      LOS SERVICIOS DE LA INICIATIVA XUGARHERO no son un dispositivo médico ni sustituyen la prospección o criterio de un médico. Se trata de una herramienta educativa y que permite una gestión de los datos asociados a las diabetes, nutrición, deporte y hábitos de vida, pero no genera diagnósticos, tratamientos o similares y SIEMPRE han de contrastarse con el criterio de un médico y/o profesional del sector.
      </p>
      <p>
      Asimismo xugarhero no se hacen responsables de la información o uso que el usuario pueda hacer de links a terceros que puedan encontrarse en los diferentes productos o servicios ofrecidos, quedando exclusivamente en manos del usuario la responsabilidad el uso que le dé a dicha información encontrada en links o derivados procedentes de terceros. A este respecto, se incluyen terceras aplicaciones que el usuario decida utilizar para la comunicación entre apps y sensores de monitorización continua de glucosa CGM, como es el caso de Diabox, nightscout o similares. xugarhero no es propietario ni tiene relación comercial con estas empresas o iniciativas, de forma que es responsabilidad del usuario final su utilización y xugarhero no se responsabiliza de las consecuencias o infracciones de copyright que estas terceras empresas puedan haber cometido o cometer en el futuro con otros actores como los fabricantes de CGM. Recordamos que los fabricantes de los sistemas CGM cuentan son sus aplicaciones oficiales para el correcto uso de los CGM con el fin de generar un diagnóstico dentro del campo de la diabetes.
      </p>
      <p>
      xugarhero recomienda el uso de CGMs comerciales, y no tiene ninguna responsabilidad sobre ellos ni sus fabricantes, quedando sobre el usuario final la relación entre empresa fabricante de los CGMs y su utilización o problemas de garantía. Así mismo, xugarhero recomienda seguir las instrucciones del fabricante de los productos CGM para su colocación y retirada una vez su vida se consuma, , sin alterar las indicaciones del fabricante y sin utilizar aplicaciones de terceros que puedan modificar las características de tiempo y durabilidad de los sistemas que el fabricante recomienda y aprueba.
      </p>
      <h3>Derechos de Propiedad Intelectual e Industrial</h3>
      <p>
      xugarhero se reserva todos los derechos de la iniciativa xugarhero y de las apps, productos o servicios asociados. Los contenidos de las apps, sitio web, incluyendo pero sin limitar a textos, imágenes, fotografías, dibujos, diseños logotipos, gráficos, marcas, iconos, combinaciones de colores o cualquier otro elemento, su estructura y diseño, la forma de presentación de los materiales incluidos en la misma y el software, links y demás contenidos audiovisuales y sonoros, así como su diseño gráfico y códigos fuente necesarios para su funcionamiento, acceso y utilización, están protegidos por los derechos de Propiedad Industrial e Intelectual, pertenecientes a xugarhero o de terceros si se diera el caso, sin que puedan entenderse cedidos los derechos de explotación de los mismos más allá de lo necesario para el servicio prestado. Cualquier reproducción, transformación, distribución, comunicación pública, puesta a disposición del público y en general cualquier otra forma de explotación, independientemente del procedimiento empleado para ello, de todo o parte de los contenidos asociados a la iniciativa en cualquier plataforma o medio queda terminantemente prohibida, así como de su diseño y la selección y forma de presentación de los materiales incluidos en la misma. Del mismo modo, queda prohibida cualquier iniciativa de ingeniería inversa asociada a un intento de copia o réplica e incluso el análisis interno de las bases, metodologías, descubrimientos e incluso el propio código fuente de cualquiera de los elementos necesarios para el correcto funcionamiento de los servicios y productos xugarhero. Las aplicaicones de terceros que el usuario considere utilizar para comunicar los CGM comerciales con las apps y servicios de xugarhero no son propiedad de xugarhero y por lo tanto, xugarhero no ostenta derechos de propiedad intelectual sobre ellos ni por ende, responsabilidad alguna sobre ellos.
      </p>
      <h3>Nulidad</h3>
      <p>
      Si en un supuesto alguna de las cláusulas aquí descritas es declarada nula, el resto seguirán vigentes.
      </p>
      <h3>Modificación de las presentes Condiciones de Uso y Aviso Legal</h3>
      <p>
      xugarhero se reserva el derecho de modificar a voluntad el presente aviso legal y condiciones de uso así como las políticas de privacidad en el momento que se considere oportuno, y quedará actualizado en este mismo link a disposición del usuario.
      </p>
      <h3>Jurisdicción y Ley aplicable</h3>
      <p>
      Todas las disposiciones del presente Aviso Legal y Condiciones de Uso se regirán o interpretarán conforme a la legislación española vigente en cada momento en aquello que no esté expresamente establecido. Usted y xugarhero acuerdan someter cualquier controversia que pudiera suscitarse respecto a lo establecido en el presente Aviso Legal y Condiciones de Uso, a los Juzgados y Tribunales del domicilio de xugarhero en Donostia.
      <p>
    </div>
    `,
  'legal-privacyPolicy': `
  <div>
     <h2>Política de Privacidad</h2>
      <p>
      xugarhero te informa sobre su Política de Privacidad respecto del tratamiento y protección de los datos de carácter personal de los usuarios y clientes que puedan ser recabados por la navegación o contratación de servicios a través de la iniciativa xugarhero y otras derivadas de xugarhero bien en sus sitios web o apps habilitadas en la AppleStore, Googleplay o cualquier otro medio físico o digital donde puedan adquirirse sus servicios y productos.
      </p>
      <p>
      En este sentido, el Titular garantiza el cumplimiento de la normativa vigente en materia de protección de datos personales, reflejada en la Ley Orgánica 3/2018, de 5 de diciembre, de Protección de Datos Personales y de Garantía de Derechos Digitales (LOPD GDD). Cumple también con el Reglamento (UE) 2016/679 del Parlamento Europeo y del Consejo de 27 de abril de 2016 relativo a la protección de las personas físicas (RGPD).
      </p>
      <p>
      El uso del sitio Web y las apps o productos y servicios asociados implica la aceptación de esta Política de Privacidad así como las condiciones incluidas en el Aviso Legal.
      </p>

      <h3>Identidad del responsable</h3>
      <ul>
        <li>Empresa: XH DIGITAL HEALTH S.L.</li>
        <li>Nombre Comercial: xugarhero</li>
        <li>B05335377</li>
        <li>Sede fiscal: Juan Fermín Gilisagasti n2 oficina 312, 20018 Donostia, Gipuzkoa (España)</li>
        <li>Correo electrónico: info@xugarhero.com</li>
        <li>Sitios web: www.xugarhero.com</li>
        <li>Aplicaciones oficiales en los Store Google Play y AppleStore.</li>
        <li>xugarhero y cualquier iniciativa derivada de ésta es propiedad del fundador de XH Digital Solutions SL y sus socios.</li>
      </ul>

      <h3>Principios aplicados en el tratamiento de datos</h3>
      <p>
      En el tratamiento de tus datos personales, el Titular aplicará los siguientes principios que se ajustan a las exigencias del nuevo reglamento europeo de protección de datos:
      </p>
      <ul>
        <li>Principio de licitud, lealtad y transparencia: El Titular siempre requerirá el consentimiento para el tratamiento de tus datos personales que puede ser para uno o varios fines específicos sobre los que te informará previamente con absoluta transparencia.</li>
        <li>Principio de minimización de datos: El Titular te solicitará solo los datos estrictamente necesarios para el fin o los fines que los solicita.</li>
        <li>Principio de limitación del plazo de conservación: Los datos se mantendrán durante el tiempo estrictamente necesario para el fin o los fines del tratamiento. El Titular te informará del plazo de conservación correspondiente según la finalidad. En el caso de suscripciones, el Titular revisará periódicamente las listas y eliminará aquellos registros inactivos durante un tiempo considerable.</li>
        <li>Principio de integridad y confidencialidad: Tus datos serán tratados de tal manera que su seguridad, confidencialidad e integridad esté garantizada. Debes saber que el Titular toma las precauciones necesarias para evitar el acceso no autorizado o uso indebido de los datos de sus usuarios por parte de terceros.</li>
      </ul>

      <h3>Obtención de datos personales</h3>
      <p>
      Para hacer uso de xugarhero es necesario que facilites datos personales, si bien existe un modo invitado con funcionalidades limitadas en el que no es necesario aportar ningún dato personal. Los casos en los que sí proporcionas tus datos personales son los siguientes:
      </p>
      <ul>
        <li>Registro en las aplicaciones y/o plataforma digital web.</li>
        <li>Hacer uso de las apps o los servicios de  xugarhero.</li>
        <li>Participar en cualquiera de los programas o análisis clínicos ligados a la iniciativa xugarhero.</li>
        <li>Al ponerte en contacto con nosotros a través del sitio web.</li>
      </ul>

      <h3>Tus derechos</h3>
      <p>
      El Titular te informa que sobre tus datos personales tienes derecho a:
      </p>
      <ul>
        <li>Solicitar el acceso a los datos almacenados.</li>
        <li>Solicitar una rectificación o la cancelación.</li>
        <li>Solicitar la limitación de su tratamiento.</li>
        <li>Oponerte al tratamiento.</li>
        <li>Solicitar la portabilidad de tus datos (se pueden realizar directamente desde el explorador para los usuarios de pago).</li>
      </ul>
      <p>
      El ejercicio de estos derechos es personal y por tanto debe ser ejercido directamente por el interesado, solicitándolo directamente al Titular, lo que significa que cualquier cliente, suscriptor o colaborador que haya facilitado sus datos en algún momento puede dirigirse al Titular y pedir información sobre los datos que tiene almacenados y cómo los ha obtenido, solicitar la rectificación de los mismos, solicitar la portabilidad de sus datos personales, oponerse al tratamiento, limitar su uso o solicitar la cancelación de esos datos en los ficheros del Titular.
      </p>
      <p>
      Para ejercitar tus derechos de acceso, rectificación, cancelación, portabilidad y oposición tienes que enviar un correo electrónico a info@xugarhero.com junto con la prueba válida en derecho como una fotocopia del D.N.I. o equivalente.
      </p>
      <p>
      Tienes derecho a la tutela judicial efectiva y a presentar una reclamación ante la autoridad de control, en este caso, la Agencia Española de Protección de Datos, si consideras que el tratamiento de datos personales que te conciernen infringe el Reglamento.
      </p>

      <h3>Finalidad del tratamiento de datos personales</h3>
      <p>
      Cuando te conectas al sitio Web o apps para mandar un correo al Titular, te suscribes a su boletín o realizas una contratación, estás facilitando información de carácter personal de la que el responsable es el Titular. Esta información puede incluir datos de carácter personal como pueden ser tu dirección IP, nombre y apellidos, dirección física, dirección de correo electrónico, número de teléfono, y otra información. Al facilitar esta información, das tu consentimiento para que tu información sea recopilada, utilizada, gestionada y almacenada por superadmin.es , sólo como se describe en el Aviso Legal y en la presente Política de Privacidad.
      </p>
      <p>
      Los datos personales y la finalidad del tratamiento por parte del Titular es diferente según el sistema de captura de información:
      </p>
      <ul>
        <li>Formularios de contacto: El Titular solicita datos personales entre los que pueden estar: Nombre y apellidos, dirección de correo electrónico, número de teléfono y dirección de tu sitio Web con la finalidad de responder a tus consultas. Por ejemplo, el Titular utiliza esos datos para dar respuesta a tus mensajes, dudas, quejas, comentarios o inquietudes que puedas tener relativas a la información incluida en el sitio Web, los servicios que se prestan a través del sitio Web, el tratamiento de tus datos personales, cuestiones referentes a los textos legales incluidos en el sitio Web, así como cualquier otra consulta que puedas tener y que no esté sujeta a las condiciones del sitio Web o de la contratación.</li>
        <li>Formularios de suscripción a contenidos: El Titular solicita los siguientes datos personales: Nombre y apellidos, dirección de correo electrónico, número de teléfono y dirección de tu sitio web para gestionar la lista de suscripciones, enviar boletines, promociones y ofertas especiales. Los datos que facilites al Titular pueden estar almacenados en empresas proveedoras de servicios contratadas por xugarhero. xugarhero no se hace responsable del uso que se den a estos datos por terceras empresas y se remite al usuario a sus respectivas políticas de privacidad para cada servicio particular no ofrecido directamente por xugarhero.</li>
      </ul>
      <p>
      Existen otras finalidades por las que el Titular trata tus datos personales:
      </p>
      <ul>
        <li>Para garantizar el cumplimiento de las condiciones recogidas en el Aviso Legal y en la ley aplicable. Esto puede incluir el desarrollo de herramientas y algoritmos que ayuden a este sitio Web a garantizar la confidencialidad de los datos personales que recoge.</li>
        <li>Para apoyar y mejorar los servicios que ofrece este sitio Web y los productos asociados a la iniciativa xugarhero.</li>
        <li>Para analizar la navegación. El Titular recoge otros datos no identificativos que se obtienen mediante el uso de cookies que se descargan en tu ordenador cuando navegas por el sitio Web y apps cuyas características y finalidad están detalladas en la Política de Cookies.</li>
        <li>Para gestionar las redes sociales. El Titular tiene presencia en redes sociales. Si te haces seguidor en las redes sociales del Titular el tratamiento de los datos personales se regirá por este apartado, así como por aquellas condiciones de uso, políticas de privacidad y normativas de acceso que pertenezcan a la red social que proceda en cada caso y que has aceptado previamente.</li>
      </ul>
      <p>
      Puedes consultar las políticas de privacidad de las principales redes sociales en estos enlaces:
      </p>
      <ul>
        <li>Facebook</li>
        <li>Twitter</li>
        <li>Linkedin</li>
        <li>YouTube</li>
        <li>Instagram</li>
        <li>Google</li>
        <li>Apple</li>
      </ul>
      <p>
      El Titular tratará tus datos personales con la finalidad de administrar correctamente su presencia en la red social, informarte de sus actividades, productos o servicios, así como para cualquier otra finalidad que las normativas de las redes sociales permitan.
      </p>
      <p>
      En ningún caso el Titular utilizará los perfiles de seguidores en redes sociales para enviar publicidad de manera individual.
      </p>

      <h3>Seguridad de los datos personales</h3>
      <p>
      Para proteger tus datos personales, el Titular toma todas las precauciones razonables y sigue las mejores prácticas de la industria para evitar su pérdida, mal uso, acceso indebido, divulgación, alteración o destrucción de los mismos.
      </p>
      <p>
      El sitio Web está alojado en Google y los servidores de la aplicación pueden estarlo en Google o AWS (Amazon). La seguridad de tus datos está garantizada, ya que toman todas las medidas de seguridad necesarias para ello. Puedes consultar su política de privacidad para tener más información.
      </p>

      <h3>Contenido de otros sitios web</h3>
      <p>
      Las páginas de este sitio Web pueden incluir contenido incrustado (por ejemplo, vídeos, imágenes, artículos, etc.). El contenido incrustado de otras web se comporta exactamente de la misma manera que si hubieras visitado la otra web.
      </p>
      <p>
      Estos sitios Web pueden recopilar datos sobre ti, utilizar cookies, incrustar un código de seguimiento adicional de terceros, y supervisar tu interacción usando este código.
      </p>

      <h3>Política de Cookies</h3>
      <p>
      Para que este sitio Web funcione correctamente necesita utilizar cookies, que es una información que se almacena en tu navegador web.
      </p>
      <p>
      En la página Política de Cookies puedes consultar toda la información relativa a la política de recogida, la finalidad y el tratamiento de las cookies.
      </p>

      <h3>Legitimación para el tratamiento de datos</h3>
      <p>
      La base legal para el tratamiento de tus datos es: el consentimiento.
      </p>
      <p>
      Para contactar con el Titular, suscribirte a un boletín o realizar comentarios en este sitio Web tienes que aceptar la presente Política de Privacidad.
      </p>

      <h3>Categorías de datos personales</h3>
      <p>
      Las categorías de datos personales que trata el Titular son:
      </p>
      <ul>
        <li>Datos identificativos.</li>
        <li>En los casos de uso de las app y plataforma digital, datos asociados a la salud, nutrición y deporte del usuario como: nivel de glucosa, actividad deportiva y constantes vitales como pulso, pasos realizados, desnivel realizado, y cualquier otro elemento y variable que identifique y describa la actividad realizada y el impacto en las constantes vitales de quien lo realiza, historial nutricional ligado a ingesta de carbohidratos, raciones, comidas, dietas, o similar, actividad de sueño y cualquier otra actividad realizada por el usuario recogida bien manualmente o bien a través de wearables o dispositivos de captación de este tipo de datos.</li>
      </ul>

      <h3>Conservación de datos personales</h3>
      <p>
      Los datos personales que proporciones al Titular se conservarán hasta que solicites su supresión.
      </p>

      <h3>Exactitud y veracidad de los datos personales</h3>
      <p>
      Te comprometes a que los datos facilitados al Titular sean correctos, completos, exactos y vigentes, así como a mantenerlos debidamente actualizados.
      </p>
      <p>
      Como Usuario del sitio Web y las apps derivadas de xugarhero eres el único responsable de la veracidad y corrección de los datos que remitas al sitio exonerando a el Titular de cualquier responsabilidad al respecto.
      </p>

      <h3>Aceptación y consentimiento</h3>
      <p>
      Como Usuario del sitio Web y las apps derivada de xugarhero declaras haber sido informado de las condiciones sobre protección de datos de carácter personal, aceptas y consientes el tratamiento de los mismos por parte de el Titular en la forma y para las finalidades indicadas en esta Política de Privacidad.
      </p>

      <h3>Revocabilidad</h3>
      <p>
      Para ejercitar tus derechos de acceso, rectificación, cancelación, portabilidad y oposición tienes que enviar un correo electrónico a baja@xugarhero.com junto con la prueba válida en derecho como una fotocopia del D.N.I. o equivalente.
      </p>
      <p>
      El ejercicio de tus derechos no incluye ningún dato que el Titular esté obligado a conservar con fines administrativos, legales o de seguridad.
      </p>

      <h3>Cambios en la Política de Privacidad</h3>
      <p>
      El Titular se reserva el derecho a modificar la presente Política de Privacidad para adaptarla a novedades legislativas o jurisprudenciales, así como a prácticas de la industria.
      </p>
      <p>
      Estas políticas estarán vigentes hasta que sean modificadas por otras debidamente publicadas.
      </p>
  </div>
  `
};



// WEBPACK FOOTER //
// ./src/brand/health/i18n/en_GB/translations.js